import React from 'react';
import { IPreloadCacheContext } from 'framework/context/IPreloadCacheContext';
import { ICommissionRulesCache } from 'gen/ApiClient';

export const CommissionRulesCacheContext = React.createContext<IPreloadCacheContext<ICommissionRulesCache>>(undefined as any);
